import React from 'react';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';
import CheckoutPage from './checkout';

const Checkout = props => {
  const postHogFlag = usePostHogFeatureFlag('singlePageCheckout');

  if (postHogFlag === 'test') {
    return <CheckoutPage singlePage {...props} />;
  }

  return <CheckoutPage singlePage={false} {...props} />;
};

export default Checkout;
